"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState, useMemo } from "react";
import type { ApiWave } from "@/generated/models/ApiWave";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { useWaveDropsLeaderboard, WaveDropsLeaderboardSort } from "@/hooks/useWaveDropsLeaderboard";
import MyStreamWaveMyVote from "./MyStreamWaveMyVote";
import { useLayout } from "../layout/LayoutContext";
import { WaveLeaderboardLoadingBar } from "@/components/waves/leaderboard/drops/WaveLeaderboardLoadingBar";
import { useIntersectionObserver } from "@/hooks/useIntersectionObserver";
import MyStreamWaveMyVotesReset from "./MyStreamWaveMyVotesReset";
interface MyStreamWaveMyVotesProps {
  readonly wave: ApiWave;
  readonly onDropClick: (drop: ExtendedDrop) => void;
}
const MyStreamWaveMyVotes: React.FC<MyStreamWaveMyVotesProps> = t0 => {
  const $ = _c(33);
  const {
    wave,
    onDropClick
  } = t0;
  const [pausePolling, setPausePolling] = useState(false);
  let t1;
  if ($[0] !== pausePolling || $[1] !== wave.id) {
    t1 = {
      waveId: wave.id,
      sort: WaveDropsLeaderboardSort.MY_REALTIME_VOTE,
      pausePolling
    };
    $[0] = pausePolling;
    $[1] = wave.id;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    drops,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isFetchingNextPage
  } = useWaveDropsLeaderboard(t1);
  const {
    myVotesViewStyle
  } = useLayout();
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = new Set();
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const [checkedDrops, setCheckedDrops] = useState(t2);
  let t3;
  bb0: {
    let t4;
    if ($[4] !== drops) {
      t4 = drops.find(_temp);
      $[4] = drops;
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    const dropWithContext = t4;
    if (!dropWithContext) {
      t3 = null;
      break bb0;
    }
    const currentVoteValue = dropWithContext.context_profile_context?.rating ?? 0;
    const maxRating = dropWithContext.context_profile_context?.max_rating;
    if (typeof maxRating !== "number") {
      t3 = null;
      break bb0;
    }
    t3 = Math.max(0, maxRating - currentVoteValue);
  }
  const sharedAvailableVotes = t3;
  let t4;
  if ($[6] !== checkedDrops || $[7] !== drops) {
    t4 = !!drops.length && drops.every(drop_0 => checkedDrops.has(drop_0.id));
    $[6] = checkedDrops;
    $[7] = drops;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const allItemsSelected = t4;
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = dropId => {
      setCheckedDrops(prev => {
        if (prev.has(dropId)) {
          prev.delete(dropId);
        } else {
          prev.add(dropId);
        }
        return new Set(prev);
      });
    };
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const handleToggleCheck = t5;
  let t6;
  if ($[10] !== allItemsSelected || $[11] !== drops) {
    t6 = () => {
      if (allItemsSelected) {
        setCheckedDrops(new Set());
      } else {
        setCheckedDrops(new Set(drops.map(_temp2)));
      }
    };
    $[10] = allItemsSelected;
    $[11] = drops;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const handleToggleSelectAll = t6;
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = dropId_0 => {
      setCheckedDrops(prev_0 => {
        prev_0.delete(dropId_0);
        return new Set(prev_0);
      });
    };
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const removeSelected = t7;
  let t8;
  if ($[14] !== fetchNextPage || $[15] !== hasNextPage || $[16] !== isFetching || $[17] !== isFetchingNextPage) {
    t8 = async () => {
      if (hasNextPage && !isFetching && !isFetchingNextPage) {
        await fetchNextPage();
      }
    };
    $[14] = fetchNextPage;
    $[15] = hasNextPage;
    $[16] = isFetching;
    $[17] = isFetchingNextPage;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  const intersectionElementRef = useIntersectionObserver(t8);
  let t9;
  if ($[19] !== allItemsSelected || $[20] !== checkedDrops || $[21] !== drops || $[22] !== handleToggleSelectAll || $[23] !== intersectionElementRef || $[24] !== isFetching || $[25] !== isFetchingNextPage || $[26] !== onDropClick || $[27] !== pausePolling || $[28] !== sharedAvailableVotes) {
    t9 = drops.length === 0 && !isFetching ? <div className="tw-mt-10"><p className="tw-text-center tw-text-sm tw-text-iron-500">You haven't voted on any submissions in this wave yet.</p></div> : <div className="tw-mt-4 tw-space-y-4"><MyStreamWaveMyVotesReset haveDrops={!!drops.length} availableVotes={sharedAvailableVotes} selected={checkedDrops} onToggleSelectAll={handleToggleSelectAll} allItemsSelected={allItemsSelected} removeSelected={removeSelected} setPausePolling={setPausePolling} /><div className="tw-space-y-2">{drops.map(drop_2 => <MyStreamWaveMyVote key={drop_2.id} drop={drop_2} onDropClick={onDropClick} isChecked={checkedDrops.has(drop_2.id)} onToggleCheck={handleToggleCheck} isResetting={pausePolling} />)}{isFetchingNextPage && <WaveLeaderboardLoadingBar />}<div ref={intersectionElementRef} /></div></div>;
    $[19] = allItemsSelected;
    $[20] = checkedDrops;
    $[21] = drops;
    $[22] = handleToggleSelectAll;
    $[23] = intersectionElementRef;
    $[24] = isFetching;
    $[25] = isFetchingNextPage;
    $[26] = onDropClick;
    $[27] = pausePolling;
    $[28] = sharedAvailableVotes;
    $[29] = t9;
  } else {
    t9 = $[29];
  }
  let t10;
  if ($[30] !== myVotesViewStyle || $[31] !== t9) {
    t10 = <div className="tw-space-y-4 tw-overflow-y-auto tw-px-2 tw-scrollbar-thin tw-scrollbar-track-iron-800 tw-scrollbar-thumb-iron-500 hover:tw-scrollbar-thumb-iron-300 sm:tw-px-4 lg:tw-space-y-6" style={myVotesViewStyle}>{t9}</div>;
    $[30] = myVotesViewStyle;
    $[31] = t9;
    $[32] = t10;
  } else {
    t10 = $[32];
  }
  return t10;
};
export default MyStreamWaveMyVotes;
function _temp(drop) {
  return drop.context_profile_context;
}
function _temp2(drop_1) {
  return drop_1.id;
}